// English customer copy follows the canonical Web v3 October 2 simplification.
// Server-owned policy/outcome text, state transitions and permitted actions remain unchanged.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "profile.loading": "Loading…",
  "profile.error.title": "We couldn’t load the booking page",
  "profile.error.body": "",
  "profile.error.retry": "Try again",
  // P-15 (approved by the Founder 2026-10-04): the honest body when App
  // Check, not the network, is why the page could not load
  // (shared/lib/appCheckRecovery).
  "appcheck.refused.body": "This browser couldn’t be verified. Try again to reload the page, or open this link in Safari or Chrome.",
  "appcheck.unreachable.body": "A security check didn’t load. An ad blocker, privacy setting or network may be blocking it. Allow it or use another browser, then try again.",
  "profile.unavailable.title": "This booking page isn’t available",
  "profile.unavailable.body": "Check the link you were given.",
  "profile.unavailable.hint": "",
  "profile.pill.payAtAppointment": "Pay at appointment",
  "profile.pill.accountRequired": "Account required",
  "profile.gated.title": "{business} books by account only",
  "profile.gated.body": "Services and prices are below — only booking itself is behind an account. Signing in first means you never lose a time you picked.",
  "profile.paused.title": "Online booking is paused",
  "profile.paused.body": "For appointments, contact {business} directly.",
  "profile.book": "Book an appointment",
  "profile.bookGated": "Sign in to book",
  "profile.signInToBook": "Sign in to book with your account",
  "flow.back": "Back",
  "flow.continue": "Continue",
  // The page layout's action bar, a labelled region (screen readers only).
  // The same words as app.*'s action bar (AppShell).
  "page.actions": "Actions",
  "flow.progress": "Step {step} of {of}",
  "flow.service.heading": "Choose a service",
  "flow.service.empty.title": "No services available.",
  "flow.service.empty.body": "",
  "flow.service.priceNote": "",
  "flow.date.heading": "Pick a day",
  "flow.date.pickADay": "Pick a day",
  "flow.time.heading": "Choose a time",
  "flow.time.previousDays": "Previous days",
  "flow.time.nextDays": "Next days",
  "flow.time.zoneNote": "Times are shown in {business}’s local time.",
  "flow.time.none.title": "No times available.",
  "flow.time.none.body": "Choose another day.",
  "flow.time.pickATime": "Pick a time",
  "flow.time.holding": "Held {time}",
  "flow.time.nothingBookedYet": "Nothing is booked until you review and confirm.",
  "flow.time.heldNote": "This time is held while you finish. If the hold runs out we’ll say so before anything is booked.",
  "flow.time.held.title": "That time is being held by someone else",
  "flow.time.held.body": "Try it again in a moment, or choose another time.",
  "flow.time.taken.title": "Choose another time",
  "flow.time.taken.body": "That time is no longer available.",
  "flow.time.expired.title": "Choose your time again",
  "flow.time.expired.body": "",
  "flow.time.failed.title": "We couldn’t hold that time",
  "flow.time.failed.body": "",
  "landing.title": "Book with a professional",
  "landing.body": "Open the booking link your professional shared.",
  "landing.hint": "",
  "notFound.title": "This page isn’t here",
  "notFound.body": "Check the booking link you were given.",
  // rc.9 DRAFT, pending the Founder's copy sheet (lura-copy-review-rc9-2026-10-15.csv).
  "release.stale.title": "A new version of Lura is ready.",
  "release.stale.body": "Reload the page to continue. You may need to enter some details again.",
  "release.stale.reload": "Reload",
  "release.stale.fallback": "If this keeps showing, close this tab and open the link again.",
  "routeError.title": "Something went wrong",
  "routeError.body": "This page didn’t load properly.",
  "routeError.retry": "try again",
  "promo.region": "Lura app",
  "promo.title": "Book with the Lura app",
  "promo.body": "Keep appointments, updates, and rebooking in one place.",
  "promo.get": "Get Lura",
  "promo.open": "Open Lura",
  "promo.dismiss": "Dismiss the Lura app prompt",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.support": "Support",
  // The legal row's accessible name (rc.7). Spanish approved by Daniel, 2026-10-14.
  "footer.navLabel": "Legal and support",
} as const;
